export const actionCreator = type => (payload, parameters) => ({
  type,
  payload,
  parameters,
  dispatchedDateTime: new Date()
})